import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { setting } from '../../../setting';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  isLoading: boolean = false;

  constructor(
    private router: Router
  ) {}

  // Restaurado solo para el modo legacy (setting.legacyAuthCookie): lee la cookie
  // auth_token cuando el backend todavía la sirve legible por JS (no HttpOnly).
  private getCookie(name: string): string | null {
    const nameEQ = encodeURIComponent(name) + '=';
    for (let c of document.cookie.split(';')) {
      c = c.trim();
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length));
      }
    }
    return null;
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

      const skipAuthHeaderPaths = [
        '/clients-updates',
        '/utilities/countries',
        '/utilities/destinations',
        '/utilities/cities',
        '/user/current',
        '/locationAgency',
        '/positionEnterprise',
        '/login',
        '/public-key',
        '/forgotAccess',
        '/joinus',
        '/contact/validate-tax-document',
        '/products/category'
      ];
      const skipAuthHeaders = skipAuthHeaderPaths.some(p => request.url.includes(p));


    // La sesión viaja en la cookie HttpOnly auth_token; el browser la adjunta
    // solo si el request pide credentials. Ya no se arma el Authorization a
    // mano porque, siendo HttpOnly, el JS no puede leer la cookie de todos modos.
    // Ojo: solo va en las llamadas a la API de booking — mandarlo a APIs de
    // terceros (octopus, etc.) rompe su CORS, que responde Allow-Origin: *
    // (incompatible con credentials).
    if (request.url.startsWith(setting.apiBookingUrl)) {
      // Switch temporal de migración (ver setting.legacyAuthCookie): si el backend
      // de este entorno todavía no sirve auth_token como HttpOnly -- o su CORS
      // todavía no está preparado para credentials (Access-Control-Allow-Origin
      // no puede ser "*" junto con withCredentials) -- se vuelve al modo de antes
      // de "cookie security": sin withCredentials, leyendo la cookie legible por
      // JS con getCookie y armando el Authorization a mano.
      if (setting.legacyAuthCookie) {
        const token = this.getCookie('auth_token');
        if (token && !request.headers.has('Authorization')) {
          request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
        }
      } else {
        request = request.clone({ withCredentials: true });
      }
    }

    if (!request.headers.has('Content-Type')) {
      request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
    }

    if (!skipAuthHeaders) {
      if (!request.headers.has('x-api-user')) {
        request = request.clone({ headers: request.headers.set('x-api-user', setting.booking_api_user) });
      }
    }
    if (!skipAuthHeaders) {
        if(!request.headers.has('x-api-key')) {
            request = request.clone({headers: request.headers.set('x-api-key', setting.booking_api_key)})
        }
      }
    request = request.clone({ headers: request.headers.set('Accept', 'application/json') });

    return next.handle(request).pipe(
    map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
      }
      return event;
    }));

  }
}
